import { render, staticRenderFns } from "./FormManageBuilding.vue?vue&type=template&id=2abc4f8e&scoped=true&"
import script from "./FormManageBuilding.vue?vue&type=script&lang=js&"
export * from "./FormManageBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abc4f8e",
  null
  
)

export default component.exports